import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCodeLarge: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCodeLarge"><Path d="M9.41406 6L3.41406 12L9.41406 18L8 19.4141L0.585938 12L8 4.58594L9.41406 6Z" fill="currentColor"/><Path d="M23.4141 12L16 19.4141L14.5859 18L20.5859 12L14.5859 6L16 4.58594L23.4141 12Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCodeLarge;
